import {InputLabel, FormGroup, Paper, TextField, Typography, FormControl, Button, MenuItem, Select, Tooltip} from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles';
import { useState, useEffect } from "react";
import { fetchallFd, fetchactiveFd, addFd, fetchFdbyId, fetchFdbyDest, updateFd} from "../api/customerapi";
import { airportlist, destAirport } from "./date";



const useStyles = makeStyles((theme) => ({
    paper: {
      marginLeft: theme.spacing(10),
      marginRight: theme.spacing(10),
      justifyContent: "center",
      backgroundColor: "#f8f8f8"
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(4),
      width: theme.spacing(60),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    headertext: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    formgroup: {
        justifyContent: "center",   
    },
    textArea: {
        marginLeft: theme.spacing(12),
        marginRight: theme.spacing(14),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
      },
    button: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(4),
        width: theme.spacing(15),
        height: theme.spacing(6),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
      },
  }));

const Fdentry = () => {

    const classes = useStyles();
    const [fdData, setfdData] =useState({
      name:"",
      journey_type:"",
      supplier_name:"",
      source_airport:"",
      destination_airport:"",
      expiry:"No",
      date_record:[],
    });
    const [allfdData, setallfdData] =useState([]);
    
        const getFd = async () => {
        try{
        const data = await fetchallFd();
        setallfdData(data.data)
    }catch(err){
        console.log(err)
      }
    }

    useEffect(() => {
        getFd()
        
        
    }, [])

    const addsp = () => {
      //console.log(spdata)
  
      setfdData({...fdData, date_record:[...fdData.date_record, {reach_day:"",
        start_date:new Date(),
        price:0,
        seats:"",}]});
    };
  
    const removesp = () => {
      //console.log(spdata)
      setfdData({...fdData, date_record:[...fdData.date_record.slice(0,fdData.date_record.length-1)]});
    };



    const handleSubmit =async (e) => {
        try{
        e.preventDefault();
        const sortedfdlistfromdb=allfdData.sort((a,b) => b.fd_id - a.fd_id);
        const highestfdid=sortedfdlistfromdb[0].fd_id;
        const newfdid = highestfdid + 1;
        const finalfdData= {...fdData, fd_id: newfdid};
        const addfdResponse= await addFd(finalfdData);
    
        if(addfdResponse.status == 200 || 201 || 202|| 203|| 204|| 205 || 206 || 207){
            alert("New FD added with fd id "+addfdResponse.data.fd_id);
            window.location = ("/fddataentry/"+addfdResponse.data.fd_id);
        }
        else{
            alert("Something went wrong. Contact support");
            window.location = ("/");
        }
     
    }catch(err){
        console.log(err)
      }
        
    }

    return ( 
        <Paper variant="outlined" className={classes.paper} elevation={10}>
            <Typography variant="h4" align="center" className={classes.headertext}> Add New FD</Typography>
            <form onSubmit={handleSubmit}>
            
            <FormGroup row className={classes.formgroup}>
                <TextField variant="standard"  required label="Name"  value={fdData.name} className={classes.textField} onChange={(e)=> setfdData({...fdData, name: e.target.value})}/>
                <FormControl style={{minWidth: 240, marginTop: 16, marginRight: 20, marginLeft: 8}}>
                <InputLabel id="JT">Journey Type</InputLabel>
                <Select displayEmpty className={classes.textField} labelId="JT" value={fdData.journey_type} onChange={(e)=> setfdData({...fdData, journey_type: e.target.value})}>
               
                <MenuItem value={"Onward"}>Onward</MenuItem>
                <MenuItem value={"Return"}>Return</MenuItem>
                </Select>
                </FormControl>
                <TextField variant="standard"  label="Supplier"  value={fdData.supplier_name} className={classes.textField} onChange={(e)=> setfdData({...fdData, supplier_name: e.target.value})}/>
            </FormGroup>
                <FormGroup row className={classes.formgroup}>
               
                <FormControl style={{minWidth: 240, marginTop: 16, marginRight: 20, marginLeft: 8}}>
                <InputLabel id="SourceAirport">Source Airport</InputLabel>
                <Select displayEmpty className={classes.textField} labelId="SourceAirport" value={fdData.source_airport} onChange={(e)=> setfdData({...fdData, source_airport: e.target.value})}>
               
                {airportlist.map(emp => {
                    return <MenuItem value={emp.airport}>{emp.airport}</MenuItem>})}
                </Select>
                </FormControl>
                <FormControl style={{minWidth: 240, marginTop: 16, marginRight: 20, marginLeft: 8}}>
                <InputLabel id="DestAirport">Destination Airport</InputLabel>
                <Select displayEmpty className={classes.textField} labelId="DestAirport" value={fdData.destination_airport} onChange={(e)=> setfdData({...fdData, destination_airport: e.target.value})}>
                {airportlist.map(emp => {
                    return <MenuItem value={emp.airport}>{emp.airport}</MenuItem>})}
                    
                </Select>
                </FormControl>
                <FormControl style={{minWidth: 240, marginTop: 16, marginRight: 20, marginLeft: 8}}>
                <InputLabel id="duration">Duration</InputLabel>
                <Select displayEmpty className={classes.textField} labelId="duration" value={fdData.duration} onChange={(e)=> setfdData({...fdData, duration: e.target.value})}>
                <MenuItem value={"3"}>3</MenuItem>
                <MenuItem value={"4"}>4</MenuItem>
                <MenuItem value={"5"}>5</MenuItem>
                <MenuItem value={"6"}>6</MenuItem>
                <MenuItem value={"7"}>7</MenuItem>  
                </Select>
                </FormControl>
                
            </FormGroup>


            <FormGroup row className={classes.formgroup}>
            <Tooltip title="Destination Start Date and Time - Stop End Date and Time || Halt time || Next Leg">
            <TextField variant="outlined"  label="Onward FLight Details"  InputLabelProps={{ shrink: true }} value={fdData.onward_flight} className={classes.textArea} fullWidth multiline rows={8} onChange={(e)=> setfdData({...fdData, onward_flight: e.target.value})}/>
            </Tooltip>
                </FormGroup>

                <FormGroup row className={classes.formgroup}>
                <Tooltip title="Destination Start Date and Time - Stop End Date and Time || Halt time || Next Leg">
            <TextField variant="outlined"  label="Return FLight Details"  InputLabelProps={{ shrink: true }} value={fdData.return_flight} className={classes.textArea} fullWidth multiline rows={8} onChange={(e)=> setfdData({...fdData, return_flight: e.target.value})}/>
            </Tooltip>
                </FormGroup>

                <FormGroup row className={classes.formgroup}>
                {fdData  && fdData.date_record.length>0 && fdData.date_record.map((item) => {
            return (
              <div id="fddates">
                <FormGroup row className={classes.formgroup}>
                  <TextField
                    variant="standard"
                    label="Start date"
                    type="date"
                    name={fdData.date_record.indexOf(item)}
                    InputLabelProps={{ shrink: true }}
                    className={classes.textField}
                    onChange={(e) => setfdData({...fdData, date_record: fdData.date_record.map(f=>fdData.date_record.indexOf(item)==fdData.date_record.indexOf(f)?{...f,start_date:e.target.value}:f)})}
                  />
                  <TextField
                    variant="standard"
                    label="Price"
                    
                    name={fdData.date_record.indexOf(item)}
                    
                    className={classes.textField}
                    onChange={(e) => setfdData({...fdData, date_record: fdData.date_record.map(f=>fdData.date_record.indexOf(item)==fdData.date_record.indexOf(f)?{...f,price:e.target.value}:f)})}
                  />
                  <TextField
                    variant="standard"
                    label="Seats"
                    
                    name={fdData.date_record.indexOf(item)}
                    
                    className={classes.textField}
                    onChange={(e) => setfdData({...fdData, date_record: fdData.date_record.map(f=>fdData.date_record.indexOf(item)==fdData.date_record.indexOf(f)?{...f,seats:e.target.value}:f)})}
                  />
                  
                </FormGroup>
                {fdData.date_record.length>0 && fdData.date_record.indexOf(item)==fdData.date_record.length-1?(
            <FormGroup row className={classes.formgroup}>
            <Button
              variant="outlined"
              color="primary"
              className={classes.button}
              onClick={()=>addsp()}
            >
              {" "}
              + Tranche
            </Button>
            <Button
              variant="outlined"
              color="secondary"
              className={classes.button}
              onClick={()=>removesp(item)}
            >
              {" "}
              - Tranche
            </Button>
            </FormGroup>
                ):("")}
                
              </div>
            );
          })}
            </FormGroup>
            {fdData.date_record.length==0?(
            <FormGroup row className={classes.formgroup}>
            <Button
              variant="outlined"
              color="primary"
              className={classes.button}
              onClick={()=>addsp()}
            >
              {" "}
              + Tranche
            </Button>
            <Button
              variant="outlined"
              color="secondary"
              className={classes.button}
              onClick={()=>removesp()}
            >
              {" "}
              - Tranche
            </Button>
            </FormGroup>
            ):("")}
            <FormGroup row className={classes.formgroup}>
                <Button variant="contained" color="primary" type="submit" className={classes.button}>Save</Button>
                <Button href="/home" variant="contained" color="secondary" className={classes.button}>Cancel</Button>
            </FormGroup>
              
            </form>
        </Paper>
     );
}

export default Fdentry;